import { useState, useRef, useCallback } from 'react';

interface GalleryItem {
  id: number;
  category: 'house' | 'grave';
  label: string;
  location: string;
  date: string;
  beforeUrl: string;
  afterUrl: string;
  description: string;
}

const galleryItems: GalleryItem[] = [
  {
    id: 1,
    category: 'grave',
    label: '산소·선산 관리',
    location: '진주시 금산면',
    date: '2024년 9월',
    beforeUrl: 'https://public.readdy.ai/ai/img_res/6f866a7212012dca8e5a45cb78bbdb0a.jpg',
    afterUrl: 'https://readdy.ai/api/search-image?query=professional%20drone%20aerial%20photography%20bird%20eye%20view%20from%20directly%20above%20beautifully%20maintained%20Korean%20ancestral%20grave%20site%20with%20neatly%20trimmed%20short%20green%20grass%2C%20clean%20visible%20stone%20markers%20and%20burial%20mounds%2C%20well-groomed%20hillside%20cemetery%2C%20authentic%20drone%20camera%20perspective%20showing%20entire%20pristine%20cemetery%20area%20from%20top%20down%2C%20bright%20natural%20sunlight%2C%20after%20professional%20maintenance%2C%20realistic%20aerial%20shot&width=700&height=500&seq=drone-after-grave-01&orientation=landscape',
    description: '수년간 방치된 선산을 드론 측량 후 엔진톱·예초기로 완전 정비'
  },
  {
    id: 2,
    category: 'house',
    label: '전원주택 정원',
    location: '진주시 이반성면',
    date: '2024년 7월',
    beforeUrl: 'https://readdy.ai/api/search-image?query=professional%20drone%20aerial%20photography%20bird%20eye%20view%20from%20directly%20above%20Korean%20countryside%20house%20with%20overgrown%20wild%20garden%2C%20tall%20weeds%20and%20grass%20covering%20entire%20yard%20and%20pathways%2C%20neglected%20traditional%20rural%20home%20exterior%20from%20top%20down%2C%20authentic%20drone%20camera%20perspective%20showing%20complete%20property%20layout%2C%20natural%20overcast%20lighting%2C%20before%20garden%20maintenance%2C%20realistic%20aerial%20shot&width=700&height=500&seq=drone-before-house-01&orientation=landscape',
    afterUrl: 'https://readdy.ai/api/search-image?query=professional%20drone%20aerial%20photography%20bird%20eye%20view%20from%20directly%20above%20Korean%20countryside%20house%20with%20beautifully%20maintained%20garden%2C%20neatly%20trimmed%20lawn%20and%20hedges%2C%20clean%20pathways%20and%20organized%20yard%2C%20well-kept%20traditional%20rural%20home%20exterior%20from%20top%20down%2C%20authentic%20drone%20camera%20perspective%20showing%20complete%20pristine%20property%20layout%2C%20bright%20sunny%20day%2C%20after%20professional%20landscaping%2C%20realistic%20aerial%20shot&width=700&height=500&seq=drone-after-house-01&orientation=landscape',
    description: '고압 세척기로 외벽·석물 세척 후 정원 전정 및 잡초 재생 방지 처리'
  },
  {
    id: 3,
    category: 'grave',
    label: '산소·선산 관리',
    location: '진주시 수곡면',
    date: '2024년 8월',
    beforeUrl: 'https://readdy.ai/api/search-image?query=professional%20drone%20aerial%20photography%20bird%20eye%20view%20from%20directly%20above%20Korean%20grave%20mound%20heavily%20overgrown%20with%20thick%20weeds%20and%20wild%20plants%20completely%20covering%20burial%20site%2C%20stone%20lanterns%20barely%20visible%20through%20dense%20vegetation%2C%20neglected%20ancestral%20grave%20from%20top%20down%2C%20authentic%20drone%20camera%20perspective%20showing%20entire%20overgrown%20area%2C%20muted%20natural%20tones%2C%20before%20professional%20cleaning%2C%20realistic%20aerial%20shot&width=700&height=500&seq=drone-before-grave-02&orientation=landscape',
    afterUrl: 'https://readdy.ai/api/search-image?query=professional%20drone%20aerial%20photography%20bird%20eye%20view%20from%20directly%20above%20perfectly%20restored%20Korean%20grave%20mound%20with%20clean%20short%20grass%2C%20clearly%20visible%20stone%20lanterns%20and%20markers%2C%20neatly%20maintained%20burial%20site%20from%20top%20down%2C%20authentic%20drone%20camera%20perspective%20showing%20entire%20pristine%20grave%20area%2C%20bright%20natural%20light%2C%20after%20professional%20maintenance%20and%20pressure%20washing%2C%20realistic%20aerial%20shot&width=700&height=500&seq=drone-after-grave-02&orientation=landscape',
    description: '석물 고압 세척 및 봉분 정비, 잡목 완전 제거 후 재생 방지 처리'
  },
  {
    id: 4,
    category: 'house',
    label: '전원주택 정원',
    location: '진주시 명석면',
    date: '2024년 6월',
    beforeUrl: 'https://readdy.ai/api/search-image?query=professional%20drone%20aerial%20photography%20bird%20eye%20view%20from%20directly%20above%20neglected%20Korean%20rural%20house%20with%20overgrown%20garden%2C%20tall%20weeds%20and%20wild%20grass%20taking%20over%20entire%20yard%2C%20untrimmed%20trees%20and%20bushes%2C%20messy%20outdoor%20space%20from%20top%20down%2C%20authentic%20drone%20camera%20perspective%20showing%20complete%20property%2C%20before%20professional%20garden%20maintenance%2C%20realistic%20aerial%20shot&width=700&height=500&seq=drone-before-house-02&orientation=landscape',
    afterUrl: 'https://readdy.ai/api/search-image?query=professional%20drone%20aerial%20photography%20bird%20eye%20view%20from%20directly%20above%20transformed%20Korean%20rural%20house%20with%20beautifully%20maintained%20garden%2C%20neatly%20mowed%20lawn%2C%20trimmed%20trees%20and%20shaped%20hedges%2C%20clean%20organized%20outdoor%20living%20space%20from%20top%20down%2C%20authentic%20drone%20camera%20perspective%20showing%20complete%20pristine%20property%2C%20warm%20afternoon%20sunlight%2C%20after%20professional%20landscaping%2C%20realistic%20aerial%20shot&width=700&height=500&seq=drone-after-house-02&orientation=landscape',
    description: '수목 전정 및 정원 전체 재정비, 드론 촬영 전/후 리포트 제공'
  }
];

function SliderCard({ item }: { item: GalleryItem }) {
  const [sliderPos, setSliderPos] = useState(50);
  const [isDragging, setIsDragging] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const updateSlider = useCallback((clientX: number) => {
    if (!containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const x = clientX - rect.left;
    const pct = Math.min(Math.max((x / rect.width) * 100, 2), 98);
    setSliderPos(pct);
  }, []);

  const onMouseDown = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const onMouseMove = useCallback((e: React.MouseEvent) => {
    if (!isDragging) return;
    updateSlider(e.clientX);
  }, [isDragging, updateSlider]);

  const onMouseUp = () => setIsDragging(false);

  const onTouchMove = useCallback((e: React.TouchEvent) => {
    updateSlider(e.touches[0].clientX);
  }, [updateSlider]);

  return (
    <div className="rounded-2xl overflow-hidden shadow-md border border-[#c9a227]/20 hover:shadow-xl hover:border-[#c9a227]/35 transition-all duration-300" style={{background: 'linear-gradient(160deg, rgba(30,58,110,0.85), rgba(13,31,60,0.95))'}}>
      {/* 슬라이더 비교 영역 */}
      <div
        ref={containerRef}
        className="relative w-full select-none overflow-hidden"
        style={{ height: '260px', cursor: isDragging ? 'ew-resize' : 'col-resize' }}
        onMouseMove={onMouseMove}
        onMouseUp={onMouseUp}
        onMouseLeave={onMouseUp}
      >
        <img src={item.afterUrl} alt="작업 후" className="absolute inset-0 w-full h-full object-cover object-top" draggable={false} />
        <div className="absolute inset-0 overflow-hidden" style={{ width: `${sliderPos}%` }}>
          <img
            src={item.beforeUrl}
            alt="작업 전"
            className="absolute inset-0 h-full object-cover object-top"
            style={{ width: `${containerRef.current ? containerRef.current.offsetWidth : 700}px`, maxWidth: 'none' }}
            draggable={false}
          />
        </div>
        <div className="absolute top-0 bottom-0 w-0.5 shadow-lg z-10" style={{ left: `${sliderPos}%`, background: '#c9a227' }} />
        <div
          className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 z-20 w-10 h-10 flex items-center justify-center rounded-full shadow-xl cursor-ew-resize border-2 border-[#c9a227]"
          style={{ left: `${sliderPos}%`, background: '#0d1f3c' }}
          onMouseDown={onMouseDown}
          onTouchStart={() => setIsDragging(true)}
          onTouchMove={onTouchMove}
          onTouchEnd={() => setIsDragging(false)}
        >
          <i className="ri-arrow-left-right-line text-[#c9a227] text-base"></i>
        </div>
        <div className="absolute top-3 left-3 z-10">
          <span className="bg-[#0d1f3c]/80 backdrop-blur-sm text-white text-xs font-bold px-2.5 py-1 rounded-lg border border-white/20">BEFORE</span>
        </div>
        <div className="absolute top-3 right-3 z-10">
          <span className="text-[#0d1f3c] text-xs font-bold px-2.5 py-1 rounded-lg" style={{background: 'linear-gradient(135deg, #e8c84a, #b8860b)'}}>AFTER</span>
        </div>
      </div>

      {/* 카드 정보 */}
      <div className="p-5">
        <div className="flex items-center gap-2 mb-2">
          <span className="text-sm font-bold px-2.5 py-1 rounded-full bg-[#c9a227]/15 text-[#c9a227] border border-[#c9a227]/30">
            {item.label}
          </span>
          <span className="text-xs text-white/40">{item.date}</span>
        </div>
        <p className="text-sm font-semibold text-white/85 mb-1 leading-snug">{item.description}</p>
        <div className="flex items-center gap-1 mt-2">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-map-pin-2-line text-sm text-[#c9a227]"></i>
          </div>
          <span className="text-xs text-white/45">{item.location}</span>
        </div>
      </div>
    </div>
  );
}

export default function BeforeAfterGallery() {
  const [activeFilter, setActiveFilter] = useState<'all' | 'house' | 'grave'>('all');

  const filtered = activeFilter === 'all' ? galleryItems : galleryItems.filter(item => item.category === activeFilter);

  return (
    <section className="relative py-20 px-6 overflow-hidden" style={{background: 'linear-gradient(145deg, #152a52 0%, #0d1f3c 55%, #111e3a 100%)'}}>
      {/* Gold vein lines */}
      <div className="absolute inset-0 opacity-[0.03]" style={{backgroundImage: 'linear-gradient(120deg, transparent 44%, #c9a227 45%, #c9a227 45.4%, transparent 46%), linear-gradient(78deg, transparent 62%, #c9a227 63%, #c9a227 63.3%, transparent 64%)', backgroundSize: '350px 350px'}}></div>

      <div className="max-w-6xl mx-auto relative z-10">
        {/* 헤더 */}
        <div className="text-center mb-12">
          <div className="inline-block bg-[#c9a227]/15 px-4 py-2 rounded-full mb-4 border border-[#c9a227]/30">
            <span className="text-base font-medium text-[#c9a227]">실제 작업 사례</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4 leading-tight">
            직접 확인하세요
          </h2>
          <p className="text-lg text-white/55 max-w-xl mx-auto">
            슬라이더를 좌우로 드래그하면 작업 전·후를 직접 비교할 수 있습니다
          </p>
        </div>

        {/* 필터 탭 */}
        <div className="flex justify-center mb-10">
          <div className="inline-flex rounded-full p-1 shadow-sm gap-1 border border-[#c9a227]/20" style={{background: 'rgba(13,31,60,0.8)'}}>
            {[
              { key: 'all', label: '전체 보기' },
              { key: 'grave', label: '산소·선산' },
              { key: 'house', label: '전원주택' }
            ].map(tab => (
              <button
                key={tab.key}
                onClick={() => setActiveFilter(tab.key as 'all' | 'house' | 'grave')}
                className={`px-6 py-2.5 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                  activeFilter === tab.key ? 'text-[#0d1f3c] font-bold shadow' : 'text-white/60 hover:text-white'
                }`}
                style={activeFilter === tab.key ? {background: 'linear-gradient(135deg, #e8c84a, #b8860b)'} : {}}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {/* 갤러리 그리드 */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {filtered.map(item => (
            <SliderCard key={item.id} item={item} />
          ))}
        </div>

        {/* 하단 안내 */}
        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-white/45">
          <div className="flex items-center gap-2">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-drone-line text-[#c9a227] text-lg"></i>
            </div>
            <span>모든 사례 드론 촬영 기록 보유</span>
          </div>
          <div className="hidden sm:block w-1 h-1 rounded-full bg-[#c9a227]/30" />
          <div className="flex items-center gap-2">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-shield-check-line text-[#c9a227] text-lg"></i>
            </div>
            <span>작업 완료 후 디지털 리포트 즉시 발송</span>
          </div>
          <div className="hidden sm:block w-1 h-1 rounded-full bg-[#c9a227]/30" />
          <div className="flex items-center gap-2">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-map-pin-2-line text-[#c9a227] text-lg"></i>
            </div>
            <span>진주 전 지역 직접 출동</span>
          </div>
        </div>
      </div>
    </section>
  );
}
